import React, { useState } from "react";

import { controlCls } from "@/shared/components/teams-ui";

/* A question's min or max: empty means no limit. The text stays as typed ("1." on its way
   to "1.5"); the number goes up once it reads as one. */
export function LimitInput({ label, value, onChange }: {
  label: string;
  value: number | undefined;
  onChange: (value: number | undefined) => void;
}) {
  const [text, setText] = useState(value === undefined ? "" : String(value));
  return (
    <label className="flex items-center gap-1.5 text-[12px] text-[var(--text-secondary)] whitespace-nowrap">
      {label}
      <input
        aria-label={label}
        inputMode="decimal"
        value={text}
        placeholder="—"
        onChange={(e) => {
          const typed = e.target.value;
          setText(typed);
          const number = Number(typed);
          if (!typed.trim()) onChange(undefined);
          else if (Number.isFinite(number)) onChange(number);
        }}
        className={`${controlCls} w-[72px] font-mono tabular-nums`}
      />
    </label>
  );
}
